<template>
  <v-card>
    <v-card-title class="headline py-2">
      Редактировать статистики монитора
      <v-spacer></v-spacer>
      <v-btn icon class="mx-0" @click="$emit('close-dialog')">
        <v-icon>close</v-icon>
      </v-btn>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <statistic-select v-model="graphs" editable></statistic-select>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions class="pa-3">
      <v-btn color="success" @click="submit" :disabled="status.btnDisabled">Сохранить</v-btn>
      <span :class="status.className" class="ml-2">{{status.text}}</span>
    </v-card-actions>
  </v-card>
</template>

<script>
  import entities from '@/mixins/entities'
  import StatisticSelect from '../../Common/StatisticSelect'
  
  export default {
    name : "MonitorStatisticsForm",
    
    mixins: [entities],
    
    components:{
      StatisticSelect
    },
    
    props : {
      id : {
        type : Number,
        required : true,
      },
    },
    
    created() {
      this.$store.dispatch( 'analytics/statistics/getMonitorGraphs', this.id ).then( graphs => {
        this.graphs = graphs
        this.graphs.map( setting => {
          this.convertOutputSettings(setting.lines)
        })
      })
    },
    
    data() {
      return {
        status : {
          btnDisabled : false,
          text : '',
          className : 'success--text darken-1'
        },
        graphs : []
      }
    },
    
    methods : {
      submit() {
        this.status = { btnDisabled : true, text : 'Сохранение', className : 'secondary--text lighten-1' }
        
        this.$store.dispatch( 'analytics/statistics/saveMonitorGraphs', {id: this.id, data: {graphs: this.graphs}} ).then( response => {
          this.status = { btnDisabled : false, text : 'Сохранено', className : 'success--text darken-1' }
          this.$emit('save', {type: 'monitorstatistics', data: {id: this.id}})
        }).catch( error => {
          this.status = { btnDisabled : false, text : 'Ошибка', className : 'error--text darken-1' }
        })
      }
    }
    
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/apps/analytics/components/Statistics/Forms/MonitorStatisticsForm.vue